import {enforce} from "vest";

export function notNull(value: any) {
  enforce(value).message('validator.not_null').isNotNullish();
}
